import React, { useEffect, useState } from "react";
import { getCorreos, postCorreo, putCorreo } from "../../componentes/http/actions/CorreoAction";
import { getClienteHabilitado } from "../../componentes/http/actions/ClientesAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Chip,
  Tooltip,
} from "@mui/material";
import NuevoCorreoModal from "../../componentes/modal/Correo/NuevoCorreoModal";
import EditarCorreoModal from "../../componentes/modal/Correo/EditarCorreoModal";

const GestorCorreos = () => {
  const [correos, setCorreos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [correoSeleccionado, setCorreoSeleccionado] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [filterCliente, setFilterCliente] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchCorreos();
    fetchClientes();
  }, []);

  const fetchCorreos = () => {
    setIsLoading(true);
    getCorreos(localStorage.getItem("token"))
      .then((response) => {
        setCorreos(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  const fetchClientes = () => {
    getClienteHabilitado(localStorage.getItem("token"))
      .then((response) => {
        setClientes(response);
      })
      .catch((error) => {
        console.log("Error al cargar clientes:", error);
      });
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const filteredCorreos = correos
    .filter((correo) => {
      const matchesSearch = correo.nombreDestinatario
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && correo.habilitado === true) ||
        (filterHabilitado === "deshabilitado" && correo.habilitado === false);
      const matchesCliente =
        filterCliente === "todos" || 
        correo.clienteId === (filterCliente === "todos" ? correo.clienteId : parseInt(filterCliente));
      return matchesSearch && matchesFilter && matchesCliente;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0); // Volver a la primera página al buscar
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0); // Volver a la primera página al filtrar
  };

  const handleClienteFilterChange = (event) => {
    setFilterCliente(event.target.value);
    setPage(0); // Volver a la primera página al filtrar por cliente
  };

  //Modal de nuevo correo
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  //Modal de editar correo
  const handleOpenEditModal = (correo) => {
    setCorreoSeleccionado(correo);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setCorreoSeleccionado(null);
  };

  const handleNuevoCorreo = async (correo) => {
    try {
      setIsLoading(true);
      await postCorreo(localStorage.getItem("token"), correo);
      await fetchCorreos();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Correo agregado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar nuevo correo:", error);
      setSnackbar({
        open: true,
        message: "Error al agregar correo",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditarCorreo = async (editado) => {
    try {
      setIsLoading(true);
      await putCorreo(localStorage.getItem("token"), editado);
      await fetchCorreos();
      handleCloseEditModal(); // Close the modal after successful edit
      setSnackbar({
        open: true,
        message: "Correo editado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar correo:", error);
      setSnackbar({
        open: true,
        message: "Error al editar correo",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderNoDataMessage = () => (
    <TableContainer component={Paper}>
      <Box p={3} sx={{ width: "100%" }}>
        <Typography variant="body1" color="text.secondary">
          No se encontraron correos con los criterios de búsqueda actuales.
        </Typography>
      </Box>
    </TableContainer>
  );

  return (
    <Grid container direction="column" spacing={2} sx={{ paddingTop: { xs: "20px", sm: "10px" } }}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Correos</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            AÑADIR CORREO
          </Button>
        </Grid>
      </Grid>
      
      {/* Filtros */}
      <Grid item>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3} md={4}>
            <TextField
              fullWidth
              label="Buscar por nombre"
              variant="outlined"
              value={searchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={2} md={3}>
            <FormControl variant="outlined" fullWidth >
              <InputLabel>Filtrar por estado</InputLabel>
              <Select
                value={filterHabilitado}
                onChange={(e) => handleFilterChange(e.target.value)}
                label="Filtrar por estado"
              >
                {filterOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
            
          <Grid item xs={12} sm={3} md={4}>
            <FormControl variant="outlined" fullWidth >
              <InputLabel>Cliente</InputLabel>
              <Select
                value={filterCliente}
                onChange={handleClienteFilterChange}
                label="Cliente"
              >
                <MenuItem value="todos">Todos</MenuItem>
                {clientes.map((cliente) => (
                  <MenuItem key={cliente.id} value={cliente.id.toString()}>
                    {cliente.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      
      {/* Tabla de datos */}
      <Grid item>
        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : filteredCorreos.length > 0 ? (
          <>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Id</TableCell>
                    <TableCell>Nombre destinatario</TableCell>
                    <TableCell>Correo destinatario</TableCell>
                    <TableCell>Cliente</TableCell>
                    <TableCell>Habilitado</TableCell>
                    <TableCell align="center">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredCorreos.map((correo, index) => (
                    <TableRow key={index}>
                      <TableCell>{correo.id}</TableCell>
                      <TableCell>{correo.nombreDestinatario}</TableCell>
                      <TableCell>{correo.correoDestinatario}</TableCell>
                      <TableCell>{correo.nombreCliente}</TableCell>
                      <TableCell>
                          <Chip
                            label={correo.habilitado ? "Sí" : "No"}
                            color={correo.habilitado ? "success" : "error"}
                            size="small"
                          />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                          <Tooltip title="Editar correo">
                            <Button
                              size="small"
                              color="primary"
                              onClick={() => handleOpenEditModal(correo)}
                            >
                              <EditNoteIcon />
                            </Button>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={
                correos.filter((correo) => {
                  const matchesSearch = correo.nombreDestinatario
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());
                  const matchesFilter =
                    filterHabilitado === "todos" ||
                    (filterHabilitado === "habilitado" && correo.habilitado === true) ||
                    (filterHabilitado === "deshabilitado" && correo.habilitado === false);
                  const matchesCliente =
                    filterCliente === "todos" || 
                    correo.clienteId === (filterCliente === "todos" ? correo.clienteId : parseInt(filterCliente));
                  return matchesSearch && matchesFilter && matchesCliente;
                }).length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        ) : (
          renderNoDataMessage()
        )}
      </Grid>
      
      {/* Modales */}
      <NuevoCorreoModal
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleNuevoCorreo}
        isLoading={isLoading}
      />
      <EditarCorreoModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleEditarCorreo}
        correo={correoSeleccionado}
      />
      
      {/* Notificaciones */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorCorreos;